import { motion } from "framer-motion";
import { Stethoscope } from "lucide-react";

/**
 * Compact editorial strip — signals founder credibility.
 * Sits between the Hero and Services.
 */
export default function BuiltBy() {
  return (
    <section
      data-testid="built-by-section"
      className="relative border-y border-white/10 py-14 sm:py-16"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-12 lg:px-24">
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
          className="grid grid-cols-1 md:grid-cols-12 gap-8 items-center"
        >
          <div className="md:col-span-3 flex items-center gap-3">
            <span className="grid place-items-center w-10 h-10 rounded-sm border border-white/15 text-white">
              <Stethoscope className="w-4 h-4" strokeWidth={2} />
            </span>
            <p className="text-[10px] tracking-[0.35em] uppercase text-slate-400 font-bold">
              Built by a UK doctor
            </p>
          </div>
          <div className="md:col-span-9">
            <p className="font-heading text-xl sm:text-2xl lg:text-3xl tracking-tight text-white leading-[1.2]">
              Designed for the healthcare clinic reality —
              <span className="text-slate-500">
                {" "}
                every workflow decision helps pave the journey between a
                patient making an enquiry and sitting in your chair.
              </span>
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
